import React, { useContext, useEffect, useState } from 'react';
import Select from 'react-select';
import { Context } from "../../state/context";

export default function PreviousTranslations({ selectedItems, onChange, onSave }) {
    const { state } = useContext(Context);

    const [previousTranslationsOptions, setPreviousTranslationsOptions] = useState([]);
    const [previousTranslations, setPreviousTranslations] = useState(false);
    const [showSave, setShowSave] = useState(false);

    useEffect(() => {
        setPreviousTranslations(selectedItems);
    }, [selectedItems]);

    useEffect(() => {
        loadOptions();
    }, [state.keys]);

    const loadOptions = () => {
        const opt = state.keys.map((key) => {
            return {
                value: key.id,
                label: key.source_string
            };
        });
        setPreviousTranslationsOptions(opt);
    }

    const handleChange = (values) => {
        if (!showSave) setShowSave(true);
        if (!values) values = [];
        onChange(values);
    }

    const handleSave = () => {
        onSave();
        setShowSave(false);
    }
    return (
        <div className='mb-4'>
            <div className={`${!onSave ? 'mb-2' : ''}`}>
              <h6 className='translation-section-title text-muted'>Add related translations</h6>
                {(previousTranslations && previousTranslationsOptions.length > 0) &&
                  <Select
                    className="cursor-pointer"
                    closeMenuOnSelect={false}
                    isMulti
                    options={previousTranslationsOptions}
                    backspaceRemovesValue={false}
                    defaultValue={previousTranslations}
                    onChange={handleChange}
                  />
                }
            </div>
            {onSave && <button className={`btn btn-mondly btn-blue mt-2 ${showSave ? '' : 'transparent'}`} onClick={handleSave}>Save</button>}
        </div>
    )
}
